import createAction from '../services/create-action';

export const FETCH_USER_SETTINGS_REQUEST = 'userSettings/FETCH_REQUEST';
export const FETCH_USER_SETTINGS_SUCCESS = 'userSettings/FETCH_SUCCESS';
export const FETCH_USER_SETTINGS_FAILURE = 'userSettings/FETCH_FAILURE';

export const fetchUserSettingsRequest = createAction(FETCH_USER_SETTINGS_REQUEST);
export const fetchUserSettingsSuccess = createAction(FETCH_USER_SETTINGS_SUCCESS);
export const fetchUserSettingsFailure = createAction(FETCH_USER_SETTINGS_FAILURE);

export const fetchUserSettings = userId => (dispatch, getState, { request }) => {
  dispatch(fetchUserSettingsRequest());

  const promise = request(`/_api/users/${userId}/settings`);

  return promise
    .then(settings => dispatch(fetchUserSettingsSuccess(settings)), () => dispatch(fetchUserSettingsFailure()))
    .then(() => promise);
};



// WEBPACK FOOTER //
// ./app/actions/fetch-user-settings.js